import CreateEmployee from "./Create Employee/CreateEmployee"
import CreateRoles from "./CreateRole/CreateRoles"
import EditViewEmp from "./EditEmployee/EditViewEmp"
import CreateDepartment from "./Create Department/CreateDepartment"
import EditRoles from "./Edit Roles/EditRoles"
export {CreateEmployee,CreateRoles,EditViewEmp,CreateDepartment,EditRoles}